<template>
  <!-- {{ item }} -->
  <div
    class="px-2.5 py-1.5 my-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-c bg-white ">
    <div class="flex justify-between items-center w-full">
      <p class="w-full m-0 text-[#9C9BBF] font-roboto text-sm">
        {{ $helper.isEmpty(item.created_at) || item.created_at == '-' ? '-' : $helper.formattedDate(item.created_at) }}
        <!-- {{ $helper.isEmpty(item.created_at) || item.created_at == '-' ? '-' : $helper.formatDateTime(item.created_at) }} -->
      </p>
    </div>
    <div
      class="relative grid grid-cols-4 tablet:grid-cols-4 laptop:grid-cols-12 largeDesktop:grid-cols-12 gap-2.5 laptop:gap-1.5 largeDesktop:gap-2.5 break-words">
      <div class="col-span-2 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 hidden">
        <span class="text-[#999999] font-roboto text-sm inline-block">ID:</span>
        <p class="m-0 font-roboto text-base font-normal">
          {{ item.bill_id }}
        </p>
      </div>
      <div class="col-span-2 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-2 pr-[10px] largeDesktop:pr-0">
        <span class="text-[#999999] font-roboto text-sm inline-block">ID:</span>
        <p class="m-0 font-roboto text-base font-normal">
          {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
        </p>
      </div>
      <div class="col-span-2 items-center justify-end mobile:flex tablet:hidden">
        <p v-if="item.status == -1"
          class="inline-block text-center font-roboto py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
          Pending
        </p>
        <p v-if="item.status == 50"
          class="inline-block text-center font-roboto py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#674188]">
          Ready
          for Payment</p>
        <p v-if="item.status == 200"
          class="inline-block text-center font-roboto py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
          Paid
        </p>
        <p v-if="item.status == 100"
          class="inline-block text-center font-roboto py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#007BFF]">
          Processed</p>
        <p v-else></p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1">
        <span class="text-[#999999] font-roboto text-sm inline-block">Consumer:</span>
        <p class="m-0 font-roboto text-base font-normal">
          {{ $helper.isEmpty(item.consumer_name) ? '-' : item.consumer_name }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-4 relative group">
        <span class="text-[#999999] font-roboto text-sm inline-block">
          Plan:
        </span>
        <!-- Show full name directly on mobile -->
        <p class="m-0 font-roboto text-base font-normal block tablet:hidden">
          {{ item.plan_name }}
        </p>
        <!-- Short name + tooltip on tablet and above -->
        <p class="m-0 font-roboto text-base font-normal relative hidden tablet:block">
          {{ getShortPlanName(item.plan_name) }}
          <span class="opacity-0 group-hover:!opacity-100 transition-opacity duration-300 max-w-[250px]
             absolute left-0 top-full mt-1 z-10 bg-white text-black text-sm
             px-2 py-1 rounded shadow-xl border border-gray-300">
            {{ item.plan_name }}
          </span>
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 hidden tablet:block">
        <span class="text-base text-[#EA8A8A] font-roboto flex">Status</span>
        <p v-if="item.status == -1"
          class="inline-block text-center font-roboto py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
          Pending
        </p>
        <p v-if="item.status == 50"
          class="inline-block text-center font-roboto py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#674188]">
          Ready
          for Payment</p>
        <p v-if="item.status == 200"
          class="inline-block text-center font-roboto py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
          Paid
        </p>
        <p v-if="item.status == 100"
          class="inline-block text-center font-roboto py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#007BFF]">
          Processed</p>
        <p v-else></p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-2">
        <span class="text-[#999999] font-roboto text-sm inline-block">Seller:</span>
        <p class="m-0 font-roboto text-base font-normal">
          {{ $helper.isEmpty(item.sold_by_name) ? '-' : item.sold_by_name }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-roboto text-sm inline-block">Amount:</span>
        <p class="m-0 font-roboto text-base font-normal">
          ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}
        </p>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  props: ["item"],
  components: {
  },
  methods: {
    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },
    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  }
};
</script>